'use client'

import { MessagingAction } from '.'
import { SlackAlertActionNode } from '../../node/types'
import DolfinRecord from '../../record'
import { DolfinRpc } from '../../rpc'
import { getBaseUrl } from '@dolfin/utils/environment'

class SlackMessageAction extends MessagingAction<SlackAlertActionNode> {
  constructor(
    node: SlackAlertActionNode,
    record: DolfinRecord,
    organizationId: number,
    rpcClient: DolfinRpc
  ) {
    super(node, record, organizationId, rpcClient)
  }
  async run() {
    const body = {
      providerConfigKey: this.node.data.formData.provider,
      connectionId: this.organizationId,
      actionName: this.node.data.formData.action_model,
      input: this.parseVariables()
    }

    const res = await fetch(getBaseUrl() + '/api/nango/action', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    if (!res.ok) {
      throw new Error(JSON.stringify(await res.json()))
    }

    return true
  }
}

export default SlackMessageAction
